// PRIYAN INTERNATIONAL LAB AND TECHNOLOGY - Main JavaScript File
const data = {
    heroImages: [
        // 'https://unsplash.it/1200/800?image=100',
        'assets/images/hero1.jpg',
        'assets/images/hero2.jpg',
        'assets/images/hero3.jpg',
      ],
}
// Global variables
let heroIndex = 0;
let mobileMenuBtn, mainNav, contactForm, tabContents, navLinks, dropdowns;
let currentTab = 'home';
let isAnimating = false;
let observerInitialized = false;
let countersAnimated = false;
let counterObserver = null;


document.addEventListener('DOMContentLoaded', function() {
    // Mobile menu toggle
    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    const navMenu = document.querySelector('nav ul');
    initializePageLoad();
    initializeElements();
    initializeAnimations();
    initHeroCarousel();
    initializeNavigation();
    initializeMobileMenu();
    // initializeContactForm();
    initializeDropdowns();
    initializeScrollEffects();
    initializeCounters();
    initializeTypewriter();
    initializeButtons();
    initializeInteractiveCards();

    // Show home tab by default with animation
    setTimeout(() => {
        console.log('[PILT LABTech] Initializing home tab on page load');
        showTab('home');
        hideLoadingOverlay();
    }, 500);

    if (mobileToggle && navMenu) {
        mobileToggle.addEventListener('click', function() {
            navMenu.classList.toggle('active');

            // Toggle hamburger icon
            const icon = this.querySelector('i');
            icon.classList.toggle('fa-bars');
            icon.classList.toggle('fa-times');
        });
    }

    // Service card interactions with smooth transitions
    const serviceCards = document.querySelectorAll('.service-card');

    serviceCards.forEach(card => {
        card.addEventListener('click', function() {
            const link = this.getAttribute('data-link');
            if (link) {
                // Add a small delay for the animation to complete
                setTimeout(() => {
                    window.location.href = link;
                }, 100);
            }
        });

        // Add ripple effect on click
        card.addEventListener('click', function(e) {
            const ripple = document.createElement('span');
            const rect = this.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;

            ripple.style.width = ripple.style.height = size + 'px';
            ripple.style.left = x + 'px';
            ripple.style.top = y + 'px';
            ripple.classList.add('ripple');

            this.appendChild(ripple);

            setTimeout(() => {
                ripple.remove();
            }, 600);
        });
    });

    // Smooth scrolling for anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    //nav link highlighting
    var navLinks = document.querySelectorAll('.nav-link');
    var current = window.location.pathname.split('/').pop() || 'index.html';
    navLinks.forEach(function(link) {
        link.classList.remove('active');
        var href = link.getAttribute('href');
        // Highlight if href matches current page
        if (href === current) {
            link.classList.add('active');
        }
        // Highlight parent if any dropdown child matches
        var parentLi = link.closest('.dropdown');
        if (parentLi) {
            var dropdownLinks = parentLi.querySelectorAll('.dropdown-link');
            dropdownLinks.forEach(function(dLink) {
                var dHref = dLink.getAttribute('href');
                if (dHref && dHref.indexOf(current) !== -1) {
                    link.classList.add('active');
                }
            });
        }
    });
    
    // Form validation and enhancement
    const contactForm = document.querySelector('#contact-form');

    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            // Basic form validation
            const name = document.querySelector('#name').value.trim();
            const email = document.querySelector('#email').value.trim();
            const message = document.querySelector('#message').value.trim();
            const phone = document.querySelector('#phone').value.trim();
            const company = document.querySelector('#company').value.trim();

            if (!name || !email || !message || !phone || !company) {
                showAlert('Please fill in all required fields.', 'error');
                return;
            }

            if (!isValidEmail(email)) {
                showAlert('Please enter a valid email address.', 'error');
                return;
            }

            if (!isValidPhone(phone)) {
                showAlert('Please enter a valid phone number.', 'error');
                return;
            }

            // console.log('Form submitted with:', { name, email, message, phone, company });
            // Show success message (in real implementation, you would send the form data)
            console.log('calling api to submit form');
            // const scriptURL = '';
            const btn = document.getElementById('submit-btn');
            btn.textContent = 'Sending...';
            console.log('Submitting contact form...', e.target);

            fetch('./contact.php', {
                method: 'POST',
                body: new FormData(e.target),
                })
                .then(res => res.json())
                .then(data => {
                // contactForm.reset();
                console.log('Response from server:', data);
                
                if (data.status === 'success') {

                    btn.textContent = 'Sent!';
                    showAlert('Thank you for your message! We will get back to you soon.', 'success');
                    setTimeout(() => {
                        btn.textContent = 'Send Message'; // or 'Send Message'
                        btn.style.backgroundColor = ''; // Reset background color
                        btn.style.color = ''; // Reset text color
                    }, 1500);
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    btn.textContent = 'Try Again';
                    showAlert('There was an error submitting your form. Please try again later.', 'error');
                }
                })
                .catch(err => {
                console.error('Error!', err.message.toString());
                btn.textContent = 'Try Again';
                showAlert('There was an error submitting your form. Please try again later.', 'error');
                });
            
        });

        // Real-time validation
        const inputs = contactForm.querySelectorAll('input, textarea');
        inputs.forEach(input => {
            input.addEventListener('blur', function() {
                validateField(this);
            });
        });
    }

    // Scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in');
            }
        });
    }, observerOptions);

    // Observe elements for animation
    const animateElements = document.querySelectorAll('.service-card, .testing-service-item, .about-content');
    animateElements.forEach(el => {
        observer.observe(el);
    });

    // Back to top button
    const backToTopButton = createBackToTopButton();
    document.body.appendChild(backToTopButton);

    window.addEventListener('scroll', function() {
        if (window.pageYOffset > 300) {
            backToTopButton.style.display = 'block';
        } else {
            backToTopButton.style.display = 'none';
        }
    });

    // Search functionality (if search box exists)
    const searchBox = document.querySelector('#search-box');
    if (searchBox) {
        searchBox.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase();
            const searchableItems = document.querySelectorAll('.testing-service-item, .service-card');

            searchableItems.forEach(item => {
                const text = item.textContent.toLowerCase();
                if (text.includes(searchTerm)) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        });
    }
});

window.addEventListener('load', function() {
    const preloader = document.getElementById('preloader');
    if (preloader) {
        console.time('startPreloader');
        preloader.style.opacity = '0';
        setTimeout(() => preloader.style.display = 'none', 300);
        console.timeEnd('startPreloader');
    }
});
// Utility functions

// ===========================================================
//  HERO CAROUSEL
// ===========================================================
function initHeroCarousel() {
    const hero = document.getElementById('hero');
    if (!hero) return;
    hero.style.backgroundImage = `url('${data.heroImages[0]}')`;
    setInterval(() => {
      heroIndex = (heroIndex + 1) % data.heroImages.length;
      hero.style.backgroundImage = `url('${data.heroImages[heroIndex]}')`;
    }, 4000);
  }
  
// Initialize interactive service cards
function initializeInteractiveCards() {
    console.log('[PILT LABTech] Initializing interactive service cards...');
    
    const interactiveCards = document.querySelectorAll('.interactive-service-card');
    
    interactiveCards.forEach(card => {
        const cardBtn = card.querySelector('.card-btn');
        const tabId = card.getAttribute('data-tab');
        
        // Handle card click
        card.addEventListener('click', function(e) {
            if (e.target === cardBtn) {
                e.stopPropagation();
                return;
            }
            
            console.log(`[PILT LABTech] Interactive card clicked: ${tabId}`);
            
            if (tabId) {
                showTab(tabId);
            }
        });
        
        // Handle button click
        if (cardBtn) {
            cardBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                console.log(`[PILT LABTech] Card button clicked: ${tabId}`);
                
                if (tabId) {
                    showTab(tabId);
                }
            });
        }
        
        // Add smooth hover effects
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.02)';
        });
        
        card.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
        });
    });
}

// Initialize buttons functionality
function initializeButtons() {
    console.log('[PILT LABTech] Initializing button functionality...');
    
    // Get Started Today button
    // const getStartedBtn = document.querySelector('.pulse-button');
    // if (getStartedBtn) {
    //     getStartedBtn.addEventListener('click', function(e) {
    //         e.preventDefault();
    //         console.log('[PILT LABTech] Get Started button clicked');
    //         showTab('contact');
    //     });
    // }
    
    // Service card clicks
    const serviceCards = document.querySelectorAll('.service-card[data-tab]');
    serviceCards.forEach(card => {
        card.addEventListener('click', function() {
            const tabId = this.getAttribute('data-tab');
            if (tabId) {
                console.log(`[PILT LABTech] Service card clicked: ${tabId}`);
                showTab(tabId);
            }
        });
    });
    
    // Dynamic button clicks
    document.addEventListener('click', function(e) {
        if (e.target.matches('.pulse-button') && e.target.textContent.includes('Contact Us Today')) {
            e.preventDefault();
            showTab('contact');
        }
    });
}

// Page Load Animation System
function initializePageLoad() {
    console.log('[PILT LABTech] Initializing page load animations...');
    const loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
        document.body.classList.add('page-loading');
    }
}

function hideLoadingOverlay() {
    console.log('[PILT LABTech] Hiding loading overlay...');
    const loadingOverlay = document.getElementById('loading-overlay');
    const body = document.body;
    
    if (loadingOverlay) {
        loadingOverlay.style.opacity = '0';
        loadingOverlay.style.visibility = 'hidden';
        
        setTimeout(() => {
            body.classList.remove('page-loading');
            animateNavigationItems();
            
            // Initialize counter animations when page loads
            setTimeout(() => {
                setupCounterObserver();
            }, 1000);
            
            setTimeout(() => {
                if (loadingOverlay.parentNode) {
                    loadingOverlay.parentNode.removeChild(loadingOverlay);
                }
            }, 500);
        }, 300);
    }
}

// Enhanced Tab Switching with Animations
function showTab(tabId) {
    // if (isAnimating || tabId === currentTab) return;
    
    console.log(`[PILT LABTech] Showing tab: ${tabId}`);
    isAnimating = true;
    
    const currentTabElement = document.querySelector('.tab-content.active, .service-tabs.active');
    if (currentTabElement) {
        currentTabElement.classList.add('fade-out');
        console.log('show tab: currentTabElement found, starting fade-out animation');
        setTimeout(() => {
            currentTabElement.classList.remove('active', 'fade-out');
            currentTabElement.style.display = 'none';
            showNewTab(tabId);
        }, 300);
    } else {
        console.log('show tab: currentTabElement not found, proceeding to show new tab directly', tabId);
        showNewTab(tabId);
    }
}

function showNewTab(tabId) {
    tabContents.forEach(content => {
        content.classList.remove('active');
        content.style.display = 'none';
    });
    
    // const serviceContainer = document.querySelector('.service-tabs');
    // if (serviceContainer) {
    //     serviceContainer.classList.remove('active');
    //     serviceContainer.style.display = 'none';
    // }
    
    // upd  atePageTitle(tabId);
    
    // if (serviceData[tabId]) {
    //     showServicePage(tabId);
    // } else {
    const targetTab = document.getElementById(tabId);
    console.log(`[PILT LABTech] Target tab element: ${targetTab}`);
    if (targetTab) {
        targetTab.style.display = 'block';
        setTimeout(() => {
            targetTab.classList.add('active');
            
            if (observerInitialized) {
                initializeTabAnimations(targetTab);
            }
            
            // Reset and setup counters if returning to home tab
            if (tabId === 'home') {
                countersAnimated = false;
                setTimeout(() => {
                    setupCounterObserver();
                }, 500);
            }
            
            isAnimating = false;
        }, 50);
        } else {
            isAnimating = false;
        }
    // }
    
    currentTab = tabId;
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
// Initialize DOM elements
function initializeElements() {
    console.log('[PILT LABTech] Getting DOM elements...');
    mobileMenuBtn = document.getElementById('mobile-menu-btn');
    mainNav = document.getElementById('main-nav');
    contactForm = document.getElementById('contact-form');
    tabContents = document.querySelectorAll('.tab-content');
    navLinks = document.querySelectorAll('.nav-link, .dropdown-link');
    dropdowns = document.querySelectorAll('.dropdown');
    
    console.log('[PILT LABTech] DOM elements retrieved successfully');
    console.log('[PILT LABTech] Mobile menu button found:', !!mobileMenuBtn);
    console.log('[PILT LABTech] Main nav found:', !!mainNav);
}

// Counter Animation System
function initializeCounters() {
    console.log('[PILT LABTech] initializeCounters function called');
}

function setupCounterObserver() {
    console.log('[PILT LABTech] Setting up counter observer...');
    
    const statisticsSection = document.getElementById('statistics-section');
    if (!statisticsSection) {
        console.warn('[PILT LABTech] Statistics section not found');
        return;
    }
    
    // Reset counters to 0 initially
    const counters = document.querySelectorAll('.counter');
    counters.forEach(counter => {
        counter.textContent = '0';
    });
    
    if (!window.IntersectionObserver) {
        console.warn('[PILT LABTech] IntersectionObserver not supported, starting counters immediately');
        setTimeout(() => triggerCounterAnimations(), 500);
        return;
    }
    
    counterObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !countersAnimated) {
                console.log('[PILT LABTech] Statistics section visible, starting counter animations');
                triggerCounterAnimations();
                counterObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
    });
    
    counterObserver.observe(statisticsSection);
    console.log('[PILT LABTech] Counter observer setup complete');
}

function triggerCounterAnimations() {
    if (countersAnimated) {
        console.log('[PILT LABTech] Counters already animated');
        return;
    }
    
    console.log('[PILT LABTech] Starting counter animations...');
    countersAnimated = true;
    
    const counters = document.querySelectorAll('.counter');
    console.log(`[PILT LABTech] Found ${counters.length} counters to animate`);
    
    counters.forEach((counter, index) => {
        const target = parseInt(counter.getAttribute('data-target'));
        const duration = parseInt(counter.getAttribute('data-duration')) || 2000;
        
        console.log(`[PILT LABTech] Counter ${index + 1}: target=${target}, duration=${duration}ms`);
        
        setTimeout(() => {
            animateCounter(counter, target, duration);
        }, index * 300);
    });
}

function animateCounter(element, target, duration) {
    if (!element || !target) {
        console.error('[PILT LABTech] Invalid counter element or target');
        return;
    }
    
    console.log(`[PILT LABTech] Starting animation for counter: ${target} over ${duration}ms`);
    
    let current = 0;
    const startTime = Date.now();
    
    function updateCounter() {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation
        const easeOutCubic = 1 - Math.pow(1 - progress, 3);
        current = Math.floor(target * easeOutCubic);
        
        element.textContent = formatNumber(current);
        
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            element.textContent = formatNumber(target);
            console.log(`[PILT LABTech] Counter animation completed: ${target}`);
        }
    }
    
    requestAnimationFrame(updateCounter);
}

function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Animation System
function initializeAnimations() {
    console.log('[PILT LABTech] Initializing animation system...');
    
    if ('IntersectionObserver' in window) {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
                    entry.target.classList.add('animated');
                }
            });
        }, observerOptions);
        
        const animatedElements = document.querySelectorAll('.animate-fade-in-up, .animate-slide-in-left, .animate-slide-in-right, .animate-slide-up, .animate-service-card, .animate-benefit, .animate-contact-item');
        animatedElements.forEach(el => observer.observe(el));
        
        observerInitialized = true;
        console.log('[PILT LABTech] Animation observer initialized');
    }
}

// Staggered Navigation Animation
function animateNavigationItems() {
    console.log('[PILT LABTech] Animating navigation items...');
    const navItems = document.querySelectorAll('.nav-item');
    navItems.forEach((item, index) => {
        setTimeout(() => {
            item.style.opacity = '1';
            item.style.transform = 'translateX(0)';
        }, index * 100);
    });
}

// Typewriter Effect
function initializeTypewriter() {
    console.log('[PILT LABTech] Initializing typewriter effects...');
    const typewriterElements = document.querySelectorAll('.typewriter');
    typewriterElements.forEach(element => {
        const text = element.dataset.text || element.textContent;
        element.textContent = '';
        element.style.borderRight = '2px solid currentColor';
        
        let i = 0;
        const typeWriter = () => {
            if (i < text.length) {
                element.textContent += text.charAt(i);
                i++;
                setTimeout(typeWriter, 100);
            } else {
                setTimeout(() => {
                    element.style.borderRight = 'none';
                }, 1000);
            }
        };
        
        setTimeout(typeWriter, 500);
    });
}

function updatePageTitle(tabId) {
    const titleMap = {
        'home': 'Advanced Laboratory Testing Solutions',
        'about': 'About PILT Testing LABTech',
        'contact': 'Contact Us',
        'testing-services': 'Testing Services Overview',
        'pt-services': 'Proficiency Testing Services',
        'rmp-services': 'Reference Material Process',
        'food-agriculture': 'Food & Agriculture Products Testing',
        'water-waste': 'Water & Wastewater Testing',
        'pharmaceuticals': 'Pharmaceutical Testing Services',
        'cosmetics': 'Cosmetics & Skin Care Testing',
        'personal-care': 'Home & Personal Care Testing',
        'fertiliser': 'Fertiliser Testing Services',
        'herbal': 'Herbal & Ayurveda Testing',
        'dietary': 'Dietary Supplements Testing',
        'medical': 'Medical Devices Testing',
        'polymer': 'Polymer & Rubber Testing',
        'training': 'Training Services',
        'method-development': 'Method Development & Validation',
        'consultancies': 'Projects & Consultancies',
        'inspection': 'Inspection Services'
    };
    
    const newTitle = titleMap[tabId] || 'PILT Testing LABTech';
    document.title = `${newTitle} - PILT Testing LABTech`;
}

function initializeTabAnimations(tabElement) {
    const animatedElements = tabElement.querySelectorAll('.animate-fade-in-up, .animate-slide-in-left, .animate-contact-item, .animate-benefit');
    
    animatedElements.forEach((el, index) => {
        el.classList.remove('animated');
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        
        setTimeout(() => {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
            el.classList.add('animated');
        }, index * 100);
    });
}

// Enhanced Service Page Generation
function showServicePage(serviceId) {
    const service = serviceData[serviceId];
    if (!service) {
        isAnimating = false;
        return;
    }
    
    let serviceContainer = document.querySelector('.service-tabs');
    if (!serviceContainer) {
        serviceContainer = document.createElement('div');
        serviceContainer.className = 'service-tabs';
        document.querySelector('.main .container').appendChild(serviceContainer);
    }
    
    serviceContainer.innerHTML = `
        <div class="service-page">
            <h2>${service.title}</h2>
            <p class="service-description">${service.description}</p>
            
            <div class="service-features">
                <h3>Key Features & Services</h3>
                <ul class="features-list">
                    ${service.features.map(feature => `<li>${feature}</li>`).join('')}
                </ul>
            </div>
            
            <div class="service-benefits">
                <h3>Benefits</h3>
                <div class="benefits-grid">
                    <div class="benefit-item">
                        <i class="fas fa-certificate"></i>
                        <h4>Certified Excellence</h4>
                        <p>All testing performed to international standards with full accreditation.</p>
                    </div>
                    <div class="benefit-item">
                        <i class="fas fa-clock"></i>
                        <h4>Fast Turnaround</h4>
                        <p>Quick and reliable results to meet your project deadlines.</p>
                    </div>
                    <div class="benefit-item">
                        <i class="fas fa-shield-alt"></i>
                        <h4>Quality Assurance</h4>
                        <p>Rigorous quality control ensures accurate and reliable results.</p>
                    </div>
                </div>
            </div>
            
            <div class="service-cta">
                <p>Need more information about our ${service.title.toLowerCase()} testing services?</p>
                <button class="btn btn--primary pulse-button">Contact Us Today</button>
            </div>
        </div>
    `;
    
    serviceContainer.style.display = 'block';
    setTimeout(() => {
        serviceContainer.classList.add('active');
        isAnimating = false;
        
        const featureItems = serviceContainer.querySelectorAll('.features-list li');
        featureItems.forEach((item, index) => {
            item.style.animationDelay = `${(index + 1) * 0.1}s`;
        });
    }, 50);
}

// Navigation functionality
function initializeNavigation() {
    console.log('[PILT LABTech] Initializing navigation...');
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const tabId = this.getAttribute('data-ta');
            const href = this.getAttribute('href');
            console.log(`[PILT LABTech] Navigation link clicked: ${this.textContent} (tabId: ${tabId}, href: ${href})`);
            // Only handle tab navigation if data-tab exists
            if (tabId && !isAnimating) {
                e.preventDefault();
                e.stopPropagation();

                console.log(`[PILT LABTech] Navigating to tab: ${tabId}`);
                showTab(tabId);
                updateActiveNavLink(this);

                if (mainNav && mainNav.classList.contains('active')) {
                    toggleMobileMenu();
                }

                closeAllDropdowns();
            } else if (href && href !== '#') {
                // For normal links, allow default navigation
                // Optionally, update active state for page navigation
                updateActiveNavLink(this);
            }
            // If href is "#" and no data-tab, do nothing
        });

        link.addEventListener('mouseenter', function() {
            if (!this.classList.contains('dropdown-toggle')) {
                this.style.transform = 'scale(1.05)';
            }
        });
        
        link.addEventListener('mouseleave', function() {
            if (!this.classList.contains('dropdown-toggle')) {
                this.style.transform = 'scale(1)';
            }
        });
    });

    // Select all submenu toggles
    const submenuToggles = document.querySelectorAll(".dropdown-submenu > .dropdown-toggle");

    // submenuToggles.forEach(toggle => {
    //     toggle.addEventListener("click", function (e) {
    //         e.preventDefault(); // Prevent navigation
    //         const submenu = this.nextElementSibling;

    //         // Close other open submenus at same level
    //         const parentMenu = this.closest(".dropdown-menu");
    //         parentMenu.querySelectorAll(".dropdown-menu.show").forEach(openMenu => {
    //             if (openMenu !== submenu) {
    //                 openMenu.classList.remove("show");
    //             }
    //         });

    //         // Toggle current submenu
    //         submenu.classList.toggle("show");
    //     });
    // });
}

// Update active navigation link
function updateActiveNavLink(activeLink) {
    document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
    });
    
    if (activeLink.classList.contains('nav-link') && !activeLink.classList.contains('dropdown-toggle')) {
        activeLink.classList.add('active');
        
        activeLink.style.animation = 'pulse 0.5s ease';
        setTimeout(() => {
            activeLink.style.animation = 'none';
        }, 500);
    } else if (activeLink.classList.contains('dropdown-link')) {
        const parentDropdown = activeLink.closest('.dropdown');
        if (parentDropdown) {
            const dropdownToggle = parentDropdown.querySelector('.dropdown-toggle');
            if (dropdownToggle) {
                dropdownToggle.classList.add('active');
            }
        }
    }
}

// Fixed Mobile Menu functionality
function initializeMobileMenu() {
    console.log('[PILT LABTech] Initializing mobile menu...');
    
    if (mobileMenuBtn && mainNav) {
        console.log('[PILT LABTech] Mobile menu elements found, setting up event listeners...');
        
        // Remove any existing event listeners
        const newMobileMenuBtn = mobileMenuBtn.cloneNode(true);
        mobileMenuBtn.parentNode.replaceChild(newMobileMenuBtn, mobileMenuBtn);
        mobileMenuBtn = newMobileMenuBtn;
        
        mobileMenuBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            console.log('[PILT LABTech] Mobile menu button clicked');
            toggleMobileMenu();
        });
        
        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
            if (mainNav && mainNav.classList.contains('active') && !e.target.closest('.header')) {
                console.log('[PILT LABTech] Clicking outside mobile menu, closing it');
                toggleMobileMenu();
            }
        });
        
        console.log('[PILT LABTech] Mobile menu initialized successfully');
    } else {
        console.warn('[PILT LABTech] Mobile menu elements not found:', {
            mobileMenuBtn: !!mobileMenuBtn,
            mainNav: !!mainNav
        });
    }
}

function toggleMobileMenu() {
    if (!mainNav || !mobileMenuBtn) {
        console.warn('[PILT LABTech] Cannot toggle mobile menu - elements missing');
        return;
    }
    
    const isActive = mainNav.classList.contains('active');
    console.log(`[PILT LABTech] Toggling mobile menu. Currently active: ${isActive}`);
    
    if (isActive) {
        // Closing menu
        mainNav.classList.remove('active');
        mobileMenuBtn.classList.remove('active');
        closeAllDropdowns();
        console.log('[PILT LABTech] Mobile menu closed');
    } else {
        // Opening menu
        mainNav.classList.add('active');
        mobileMenuBtn.classList.add('active');
        console.log('[PILT LABTech] Mobile menu opened');
        
        // Animate menu items with a slight delay to ensure visibility
        setTimeout(() => {
            const navItems = mainNav.querySelectorAll('.nav-item');
            console.log(`[PILT LABTech] Animating ${navItems.length} navigation items`);
            
            navItems.forEach((item, index) => {
                item.style.opacity = '0';
                item.style.transform = 'translateX(-20px)';
                setTimeout(() => {
                    item.style.opacity = '1';
                    item.style.transform = 'translateX(0)';
                }, index * 50);
            });
        }, 50);
    }
}

// Dropdown functionality
function initializeDropdowns() {
    if (!dropdowns) return;
    
    console.log(`[PILT LABTech] Initializing ${dropdowns.length} dropdowns...`);
    
    dropdowns.forEach((dropdown, index) => {
        const toggle = dropdown.querySelector('.dropdown-toggle');
        const menu = dropdown.querySelector('.dropdown-menu');
        
        if (toggle && menu) {
            // Mobile dropdown handling
            toggle.addEventListener('click', function(e) {
                if (window.innerWidth <= 900) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    console.log(`[PILT LABTech] Mobile dropdown ${index + 1} clicked`);
                    
                    // Close other dropdowns
                    dropdowns.forEach(otherDropdown => {
                        if (otherDropdown !== dropdown) {
                            otherDropdown.classList.remove('active');
                        }
                    });
                    
                    dropdown.classList.toggle('active');
                    
                    if (dropdown.classList.contains('active')) {
                        const dropdownItems = menu.querySelectorAll('li');
                        dropdownItems.forEach((item, itemIndex) => {
                            item.style.opacity = '0';
                            item.style.transform = 'translateX(-20px)';
                            setTimeout(() => {
                                item.style.opacity = '1';
                                item.style.transform = 'translateX(0)';
                            }, itemIndex * 50);
                        });
                    }
                }
            });
            
            // Desktop hover handling
            if (window.innerWidth > 900) {
                dropdown.addEventListener('mouseenter', function() {
                    this.classList.add('active');
                });
                
                dropdown.addEventListener('mouseleave', function() {
                    this.classList.remove('active');
                });
            }
        }
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.dropdown')) {
            closeAllDropdowns();
        }
    });
}

function closeAllDropdowns() {
    if (dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.classList.remove('active');
        });
    }
}

// Scroll Effects
function initializeScrollEffects() {
    const header = document.getElementById('main-header');
    let lastScrollTop = 0;
    
    window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 100) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
        
        const hero = document.querySelector('.hero');
        if (hero && scrollTop < hero.offsetHeight) {
            const parallaxOffset = scrollTop * 0.5;
            hero.style.transform = `translateY(${parallaxOffset}px)`;
        }
        
        lastScrollTop = scrollTop;
    });
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function isValidPhone(phone) {
    // Basic phone validation: allows +, digits, spaces, and dashes
    const phoneRegex = /^(\+91[\s-]?|91[\s-]?|0)?[6-9]\d{9}$/;
    return phoneRegex.test(phone);
}

function handleResponsive() {
    if (window.innerWidth > 900 && mainNav && mainNav.classList.contains('active')) {
        toggleMobileMenu();
    }
    
    closeAllDropdowns();
    
    setTimeout(() => {
        initializeDropdowns();
    }, 100);
}

function validateField(field) {
    const value = field.value.trim();
    const fieldName = field.getAttribute('name');

    // Remove existing error styling
    field.classList.remove('error');

    if (fieldName === 'email' && value && !isValidEmail(value)) {
        field.classList.add('error');
        return false;
    }

    if (field.hasAttribute('required') && !value) {
        field.classList.add('error');
        return false;
    }

    return true;
}

function showAlert(message, type) {
    // Create alert element
    const alert = document.createElement('div');
    alert.className = `alert alert-${type}`;
    alert.textContent = message;

    // Style the alert
    alert.style.cssText = `
        position: fixed;
        top: 100px;
        right: 20px;
        padding: 1rem 1.5rem;
        border-radius: 5px;
        color: white;
        font-weight: bold;
        z-index: 10000;
        max-width: 300px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transform: translateX(100%);
        transition: transform 0.3s ease;
    `;

    if (type === 'success') {
        alert.style.backgroundColor = '#617742';
    } else {
        alert.style.backgroundColor = '#dc3545';
    }

    document.body.appendChild(alert);

    // Animate in
    setTimeout(() => {
        alert.style.transform = 'translateX(0)';
    }, 100);

    // Remove after 5 seconds
    setTimeout(() => {
        alert.style.transform = 'translateX(100%)';
        setTimeout(() => {
            document.body.removeChild(alert);
        }, 300);
    }, 5000);
}

function createBackToTopButton() {
    const button = document.createElement('button');
    button.innerHTML = '<i class="fas fa-arrow-up"></i>';
    button.className = 'back-to-top';
    button.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #247194;
        color: white;
        border: none;
        cursor: pointer;
        display: none;
        z-index: 1000;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transition: all 0.3s ease;
    `;

    button.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    button.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#617742';
        this.style.transform = 'scale(1.1)';
    });

    button.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '#247194';
        this.style.transform = 'scale(1)';
    });

    return button;
}


// Add CSS for ripple effect and error styling
const style = document.createElement('style');
style.textContent = `
    .ripple {
        position: absolute;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.6);
        transform: scale(0);
        animation: ripple 0.6s linear;
        pointer-events: none;
    }

    @keyframes ripple {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }

    .form-group input.error,
    .form-group textarea.error {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    .alert {
        animation: slideIn 0.3s ease;
    }

    @keyframes slideIn {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }
`;
document.head.appendChild(style);


// Product data
const productsData = [
    {"name": "Albendazole", "category": "CRM/TWS", "description": "Used for analytical method validation and QC of antiparasitic drugs"},
    {"name": "Amlodipine Besylate", "category": "CRM/TWS", "description": "For assay and content uniformity testing in cardiovascular drugs"},
    {"name": "Amoxycillin Trihydrate", "category": "CRM/TWS", "description": "Used for antibiotic potency and stability studies"},
    {"name": "Ascorbic Acid", "category": "CRM/TWS", "description": "Nutritional reference standard for supplement and food analysis"},
    {"name": "Azithromycin", "category": "CRM/TWS", "description": "Reference for antibiotic content analysis and dissolution testing"},
    {"name": "Aceclofenac", "category": "CRM/TWS", "description": "Reference material for drug assay and quality control"},
    {"name": "Benzhexol Hydrochloride", "category": "CRM/TWS", "description": "Used for identity and assay testing of anticholinergic compounds"},
    {"name": "Benzocaine", "category": "CRM/TWS", "description": "Reference standard for local anesthetic assay and purity testing"},
    {"name": "Buffer Solution (pH 4.0)", "category": "CRM", "description": "Ready-to-use buffer for pH calibration and analytical testing"},
    {"name": "Buffer Solution (pH 7.0)", "category": "CRM", "description": "pH calibration standard for laboratory instruments"},
    {"name": "Buffer Solution (pH 9.0)", "category": "CRM", "description": "Alkaline buffer solution for calibration and stability verification"},
    {"name": "Caffeine", "category": "CRM", "description": "Used for purity, identity, and release testing of stimulants"},
    {"name": "Carbimazole", "category": "CRM/TWS", "description": "Reference for thyroid drug assay validation"},
    {"name": "Ciprofloxacin Hydrochloride", "category": "CRM/TWS", "description": "Analytical reference for fluoroquinolone antibiotics"},
    {"name": "Clotrimazole", "category": "CRM/TWS", "description": "Used for antifungal assay and impurity profiling"},
    {"name": "Diclofenac Sodium", "category": "CRM/TWS", "description": "Anti-inflammatory drug reference for potency and content testing"},
    {"name": "Dicyclomine HCl", "category": "CRM/TWS", "description": "For analytical verification of antispasmodic formulations."},
    {"name": "Domperidone Maleate", "category": "CRM/TWS", "description": "Reference standard for gastrointestinal drug analysis"},
    {"name": "Drotaverine Hydrochloride", "category": "CRM/TWS", "description": "Used for assay and related-substance studies of smooth-muscle relaxants"},
    {"name": "Furazolidone", "category": "CRM/TWS", "description": "Pharmaceutical grade reference material for drug analysis and quality control"},
    {"name": "Ketoconazole", "category": "CRM/TWS", "description": "Antifungal reference standard for potency and purity analysis"},
    {"name": "Lignocaine Hydrochloride", "category": "CRM/TWS", "description": "Local anesthetic standard for assay and impurity control"},
    {"name": "Luliconazole", "category": "CRM/TWS", "description": "Dermatological antifungal standard for QC testing"},
    {"name": "Mefenamic Acid", "category": "CRM/TWS", "description": "For pain-relief drug quality control and validation"},
    {"name": "Metformin", "category": "CRM/TWS", "description": "Antidiabetic reference material for potency and impurity determination"},
    {"name": "Methyl Paraben", "category": "CRM/TWS", "description": "Preservative standard for food, cosmetic, and pharma formulations"},
    {"name": "Methylcobalamin", "category": "CRM/TWS", "description": "Vitamin B₁₂ reference for supplement testing"},
    {"name": "Nicotinamide", "category": "CRM/TWS", "description": "Vitamin B₃ reference for food and nutraceutical testing"},
    {"name": "Ofloxacin", "category": "CRM/TWS", "description": "Antibacterial assay reference material"},
    {"name": "Pantoprazole Sodium", "category": "CRM/TWS", "description": "Proton-pump inhibitor reference for assay and degradation studies"},
    {"name": "Paracetamol", "category": "CRM/TWS", "description": "Widely used reference for analgesic and antipyretic drug testing"},
    {"name": "Pregabalin", "category": "CRM/TWS", "description": "Reference for anticonvulsant and neuropathic-pain drug analysis"},
    {"name": "Propyl Paraben", "category": "CRM/TWS", "description": "Preservative standard for personal-care and food QC"},
    {"name": "Pyridoxine HCl", "category": "CRM/TWS", "description": "Vitamin B₆ standard for nutritional analysis"},
    {"name": "Riboflavin", "category": "CRM/TWS", "description": "Vitamin B₂ reference for supplement and food QC"},
    {"name": "Sodium Tartrate Dihydrate", "category": "CRM", "description": "Used for moisture analysis and volumetric calibration"},
    {"name": "Sucrose", "category": "CRM", "description": "CRM accredited reference material for calibration and analytical testing"},
    {"name": "Thiamine HCl", "category": "CRM/TWS", "description": "Vitamin B₁ standard for nutritional products"}
];

// Global variables
let allProducts = [];
let filteredProducts = [];

// Category mapping for CSS classes
const categoryClassMap = {
    'CRM/TWS': 'category-pharmaceutical',
    'CRM/TWS': 'category-vitamin',
    'Buffer Standard': 'category-buffer',
    'CRM/TWS': 'category-food',
    'CRM/TWS': 'category-crm'
};

// Initialize the application when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    initializeProducts();
    renderProducts();
    setupEventListeners();
    updateResultsCount();
});

function initializeProducts() {
    // Sort products alphabetically
    allProducts = [...productsData].sort((a, b) => a.name.localeCompare(b.name));
    filteredProducts = [...allProducts];
}

function setupEventListeners() {
    // Search functionality with multiple event listeners for better responsiveness
    const searchInput = document.getElementById('searchInput');
    if (searchInput) {
        // Clear any existing event listeners
        searchInput.removeEventListener('input', handleSearch);
        searchInput.removeEventListener('keyup', handleSearch);
        
        // Add event listeners
        searchInput.addEventListener('input', handleSearch);
        searchInput.addEventListener('keyup', handleSearch);
        searchInput.addEventListener('change', handleSearch);
    }

    // Alphabet navigation
    const alphabetLetters = document.querySelectorAll('.alphabet-letter[data-letter]');
    
    alphabetLetters.forEach(letter => {
        // Remove existing listeners to prevent duplicates
        letter.removeEventListener('click', handleAlphabetClick);
        
        // Add new listener
        letter.addEventListener('click', handleAlphabetClick);
    });

    // Update active alphabet letter on scroll
    window.addEventListener('scroll', debounce(updateActiveLetterOnScroll, 100));
}

function handleAlphabetClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const targetLetter = this.getAttribute('data-letter');
    if (targetLetter) {
        scrollToSection(targetLetter);
        updateActiveAlphabetLetter(targetLetter);
    }
}

function handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    
    if (searchTerm === '') {
        filteredProducts = [...allProducts];
    } else {
        filteredProducts = allProducts.filter(product => 
            product.name.toLowerCase().includes(searchTerm) ||
            product.category.toLowerCase().includes(searchTerm) ||
            product.description.toLowerCase().includes(searchTerm)
        );
    }
    
    renderProducts();
    updateResultsCount();
}

function renderProducts() {
    // Clear all product grids first
    const productGrids = document.querySelectorAll('.products-grid');
    productGrids.forEach(grid => {
        if (grid) grid.innerHTML = '';
    });

    // Hide all sections initially
    const allSections = document.querySelectorAll('.letter-section');
    allSections.forEach(section => {
        section.classList.add('hidden');
    });

    // Group products by first letter
    const productsByLetter = {};
    filteredProducts.forEach(product => {
        const firstLetter = product.name.charAt(0).toUpperCase();
        if (!productsByLetter[firstLetter]) {
            productsByLetter[firstLetter] = [];
        }
        productsByLetter[firstLetter].push(product);
    });

    // Render products in their respective sections
    Object.keys(productsByLetter).forEach(letter => {
        const grid = document.getElementById(`products-${letter}`);
        const section = document.getElementById(`section-${letter}`);
        
        if (grid && section) {
            grid.innerHTML = '';
            
            productsByLetter[letter].forEach(product => {
                const productCard = createProductCard(product);
                grid.appendChild(productCard);
            });
            
            // Show the section
            section.classList.remove('hidden');
        }
    });
}

function createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'product-card';
    
    const categoryClass = categoryClassMap[product.category] || 'category-crm';
    
    card.innerHTML = `
        <h4 class="product-name">${escapeHtml(product.name)}</h4>
        <p class="product-description">${escapeHtml(product.description)}</p>
        <span class="product-category ${categoryClass}">${escapeHtml(product.category)}</span>
    `;
    
    return card;
}

function escapeHtml(text) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

function scrollToSection(letter) {
    const section = document.getElementById(`section-${letter}`);
    
    if (!section) {
        return;
    }
    
    // Check if section is visible (not hidden)
    if (section.classList.contains('hidden')) {
        return;
    }
    
    // Calculate scroll position
    const alphabetNav = document.querySelector('.alphabet-nav');
    const navHeight = alphabetNav ? alphabetNav.offsetHeight : 0;
    const headerOffset = navHeight + 20; // Extra padding
    
    // Use getBoundingClientRect for more accurate positioning
    const rect = section.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = rect.top + scrollTop - headerOffset;
    
    // Force scroll using multiple methods for better browser compatibility
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
    
    // Fallback for browsers that don't support smooth scrolling
    setTimeout(() => {
        if (Math.abs(window.scrollY - targetPosition) > 50) {
            window.scrollTo(0, targetPosition);
        }
    }, 100);
}

function updateActiveAlphabetLetter(activeLetter) {
    const alphabetLetters = document.querySelectorAll('.alphabet-letter');
    alphabetLetters.forEach(letter => {
        letter.classList.remove('active');
        if (letter.getAttribute('data-letter') === activeLetter) {
            letter.classList.add('active');
        }
    });
}

function updateActiveLetterOnScroll() {
    const sections = document.querySelectorAll('.letter-section:not(.hidden)');
    const scrollPosition = window.scrollY + 200; // Adjusted offset
    
    let currentSection = null;
    let closestDistance = Infinity;
    
    sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + window.scrollY;
        const distance = Math.abs(scrollPosition - sectionTop);
        
        if (distance < closestDistance && scrollPosition >= sectionTop - 100) {
            closestDistance = distance;
            currentSection = section.id.split('-')[1];
        }
    });
    
    if (currentSection) {
        updateActiveAlphabetLetter(currentSection);
    }
}

function updateResultsCount() {
    const resultsCount = document.getElementById('resultsCount');
    if (resultsCount) {
        const count = filteredProducts.length;
        const productText = count === 1 ? 'product' : 'products';
        resultsCount.textContent = `${count} ${productText} found`;
    }
}

// Utility function for debouncing
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Handle keyboard navigation for accessibility
document.addEventListener('keydown', function(event) {
    if (event.target.classList.contains('alphabet-letter') && event.key === 'Enter') {
        event.preventDefault();
        event.target.click();
    }
});

// Focus management for accessibility
function setupKeyboardNavigation() {
    const alphabetLetters = document.querySelectorAll('.alphabet-letter[data-letter]');
    
    alphabetLetters.forEach((letter, index) => {
        letter.setAttribute('tabindex', index === 0 ? '0' : '-1');
        
        letter.addEventListener('keydown', function(event) {
            let targetIndex = index;
            
            switch(event.key) {
                case 'ArrowLeft':
                    event.preventDefault();
                    targetIndex = index > 0 ? index - 1 : alphabetLetters.length - 1;
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    targetIndex = index < alphabetLetters.length - 1 ? index + 1 : 0;
                    break;
                case 'Home':
                    event.preventDefault();
                    targetIndex = 0;
                    break;
                case 'End':
                    event.preventDefault();
                    targetIndex = alphabetLetters.length - 1;
                    break;
                default:
                    return;
            }
            
            // Update tabindex
            alphabetLetters.forEach(l => l.setAttribute('tabindex', '-1'));
            alphabetLetters[targetIndex].setAttribute('tabindex', '0');
            alphabetLetters[targetIndex].focus();
        });
    });
}

// Initialize keyboard navigation after a short delay
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        setupKeyboardNavigation();
    }, 200);
});

// Add a clear search function for better UX
function clearSearch() {
    const searchInput = document.getElementById('searchInput');
    if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
}



(function initMarquee(){
  const SPEED_PX_PER_SEC = 120; // tweak: higher = faster

  function setupMarquee(marquee){
    const viewport = marquee.querySelector('.marquee__viewport');
    const track = marquee.querySelector('.marquee__track');
    const originalGroup = marquee.querySelector('.marquee__group');
    if (!viewport || !track || !originalGroup) return;

    // ensure there are at least two identical groups for seamless loop
    const groups = marquee.querySelectorAll('.marquee__group');
    if (groups.length < 2) {
      const clone = originalGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // If content is shorter than viewport, duplicate until it fills more than viewport
    const ensureFill = () => {
      const firstGroupWidth = originalGroup.scrollWidth;
      let totalGroupWidth = 0;
      marquee.querySelectorAll('.marquee__group').forEach(g => totalGroupWidth += g.scrollWidth);
      let idx = 0;
      while (totalGroupWidth < viewport.clientWidth + firstGroupWidth) {
        const extra = originalGroup.cloneNode(true);
        extra.setAttribute('aria-hidden', 'true');
        track.appendChild(extra);
        totalGroupWidth += originalGroup.scrollWidth;
        if (++idx > 10) break; // safety
      }
    };

    const recalc = () => {
      // small timeout to allow fonts/images layout
      setTimeout(() => {
        ensureFill();
        const vw = viewport.clientWidth;
        const blockWidth = originalGroup.scrollWidth; // width of one group
        // distance to move = viewport (start off right) + blockWidth (end off left)
        const distance = vw + blockWidth;
        const duration = Math.max(3, distance / SPEED_PX_PER_SEC); // secs
        // set CSS vars used by keyframes
        track.style.setProperty('--marquee-start', vw + 'px');
        track.style.setProperty('--marquee-end', -blockWidth + 'px');
        track.style.setProperty('--marquee-duration', duration + 's');

        // restart animation to pick up new duration/vars (avoid jump)
        track.style.animation = 'none';
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        track.offsetHeight;
        track.style.animation = `marquee-move ${duration}s linear infinite`;
        // after setting track.style.animation = `marquee-move ${duration}s linear infinite`;
        track.style.animationPlayState = 'running';

        // also handle pointerenter/pointerleave so pause works reliably on more devices
        track.addEventListener('pointerenter', () => { track.style.animationPlayState = 'paused'; });
        track.addEventListener('pointerleave', () => { track.style.animationPlayState = 'running'; });
        
      }, 50);
    };

    recalc();
    // recompute on resize / font load
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalc, 120);
    });
    // also guard for images/fonts loaded after DOMContentLoaded
    window.addEventListener('load', recalc);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.marquee').forEach(setupMarquee);
  });
})();


document.addEventListener('DOMContentLoaded', function initRatesModal() {
  try {
    const openBtns = Array.from(document.querySelectorAll('.open-rates-modal, #viewRatesBtn'));
    const modal = document.getElementById('ratesModal');
    const dialog = modal ? modal.querySelector('[role="dialog"]') || modal : null;
    const closeBtn = modal ? modal.querySelector('#closeModal') : null;
    const cancelBtn = modal ? modal.querySelector('#cancelForm') : null;
    const form = document.getElementById('ratesForm');
    const formMsg = document.getElementById('formMsg');
    const ratesBlock = document.getElementById('ratesBlock');
    const ratesTitle = document.getElementById('ratesTitle');
    const downloadLink = document.getElementById('downloadRates');

    if (!modal || !form || openBtns.length === 0) {
      console.warn('Rates modal: required elements missing', { modal: !!modal, form: !!form, openBtns: openBtns.length });
      return;
    }

    function openModal(e) {
      if (e) e.preventDefault();
      modal.style.display = 'flex';
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // show form, hide rates block
      form.style.display = '';
      if (ratesBlock) ratesBlock.style.display = 'none';
      // reset state
      form.reset();
      if (formMsg) { formMsg.style.display = 'none'; formMsg.textContent = ''; }
      // focus first field
      const first = form.querySelector('input[name="name"], input[type="text"], input[type="email"]');
      if (first) first.focus();
    }

    function closeModal() {
      modal.style.display = 'none';
      document.getElementById('closeModal').blur();
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Open handlers
    openBtns.forEach(btn => btn.addEventListener('click', openModal));

    // Close handlers
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (cancelBtn) cancelBtn.addEventListener('click', closeModal);

    // Backdrop click
    modal.addEventListener('click', (ev) => {
      if (ev.target === modal) closeModal();
    });

    // ESC key
    document.addEventListener('keydown', (ev) => {
      if ((ev.key === 'Escape' || ev.key === 'Esc') && modal.style.display === 'flex') {
        closeModal();
      }
    });

    // Submit handler
    form._ratesSubmitHandler && form.removeEventListener('submit', form._ratesSubmitHandler);
    form._ratesSubmitHandler = async function (ev) {
      ev.preventDefault();
      if (formMsg) { formMsg.style.display = 'none'; formMsg.textContent = ''; }

      // honeypot
      if (form.website && form.website.value.trim() !== '') {
        if (formMsg) { formMsg.textContent = 'Spam detected.'; formMsg.style.display = 'block'; }
        return;
      }

      const name = (form.name && form.name.value || '').trim();
      const email = (form.email && form.email.value || '').trim();
      const phone = (form.phone && form.phone.value || '').trim();
      const company = (form.company && form.company.value || '').trim();
      const consent = form.querySelector('input[name="consent"]');

      if (!name || !email || !phone || !consent || !consent.checked) {
        if (formMsg) { formMsg.textContent = 'Please complete required fields and accept contact consent.'; formMsg.style.display = 'block'; }
        return;
      }

      const submitBtn = form.querySelector('button[type="submit"]');
      const origText = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Preparing...';
      }

      try {
        const fd = new FormData(form);
        fd.append('source', 'rates-modal');
        fd.append('message', 'RMP Rate List Downloaded'); // static backend-only value

        const res = await fetch('./contact.php', { method: 'POST', body: fd, credentials: 'same-origin' });
        const result = await res.json().catch(() => ({ status: 'error', message: 'Invalid server response' }));

        if (result.status === 'success') {
          // show rates and hide form
          if (ratesBlock) ratesBlock.style.display = 'block';
          form.style.display = 'none';
          if (ratesTitle) ratesTitle.textContent = `Thank you, ${name}. Please download the rate list:`;
          if (downloadLink) downloadLink.focus();
          
        } else {
          if (formMsg) { formMsg.textContent = result.message || 'Unable to submit. Please try again later.'; formMsg.style.display = 'block'; }
        }
      } catch (err) {
        console.error('Rates form submit error', err);
        if (formMsg) { formMsg.textContent = 'Network error. Please try again later.'; formMsg.style.display = 'block'; }
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = origText || 'View Rates';
        }
      }
    };
    form.addEventListener('submit', form._ratesSubmitHandler);

  } catch (err) {
    console.error('Rates modal init error', err);
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const rmpBtn = document.querySelector('.btn-hero.rmp-brochure'); // add class to target element
    if (rmpBtn) {
        rmpBtn.addEventListener('click', () => {
            // same-page anchor: location.hash = '#quote';
            // navigate to another page:
            window.location.href = 'rmp-broucher.html';
            // open in new tab: window.open('rmp-broucher.html', '_blank');
        });
    }

});



document.addEventListener('DOMContentLoaded', function () {
  try {
    const valueList = document.querySelector('.value-list');
    // const menuBtn = document.querySelector('.mobile-menu-btn');
    // const nav = document.querySelector('.nav');
    // if (menuBtn && nav) {
    // menuBtn.addEventListener('click', () => {
    //     menuBtn.classList.toggle('active');
    //     nav.classList.toggle('active');
    // });
    // }

    if (valueList) {
      // optionally set first item as selected by default
      const first = valueList.querySelector('li');
      if (first) first.classList.add('selected');

      valueList.addEventListener('click', function (ev) {
        const li = ev.target.closest('li');
        if (!li) return;
        // toggle single selection
        valueList.querySelectorAll('li').forEach(item => item.classList.remove('selected'));
        li.classList.add('selected');
        // optional: scroll into view or take other action
        // li.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  } catch (err) {
    console.error('value-list init error', err);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const menuBtn = document.getElementById("mobile-menu-btn");
  const closeBtn = document.getElementById("close-nav");
  const mobileNav = document.getElementById("mobile-nav");

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", () => {
      mobileNav.classList.add("open");
      document.body.classList.add("menu-open");
      document.body.style.overflow = "hidden"; // 🚫 Disable scroll
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        mobileNav.classList.remove("open");
        document.body.classList.remove("menu-open");
        document.body.style.overflow = ""; // ✅ Restore scroll
      });
    }

    // Close if user clicks outside drawer
    document.addEventListener("click", (e) => {
      if (!mobileNav.contains(e.target) && !menuBtn.contains(e.target)) {
        mobileNav.classList.remove("open");
        document.body.classList.remove("menu-open");
        document.body.style.overflow = ""; // ✅ Restore scroll
      }
    });

    // Optional: Close when a menu link is clicked
    document.querySelectorAll(".mobile-nav-list a").forEach(link => {
      link.addEventListener("click", () => {
        mobileNav.classList.remove("open");
        document.body.classList.remove("menu-open");
        document.body.style.overflow = ""; // ✅ Restore scroll
      });
    });
  }
});


// document.addEventListener("DOMContentLoaded", function() {
//   const menuBtn = document.getElementById("mobile-menu-btn");
//   const closeBtn = document.getElementById("close-nav");
//   const mobileNav = document.getElementById("mobile-nav");

//   if (menuBtn && mobileNav) {
//     menuBtn.addEventListener("click", () => {
//       mobileNav.classList.add("open");
//       document.body.classList.add("menu-open");
//     });

//     closeBtn.addEventListener("click", () => {
//       mobileNav.classList.remove("open");
//       document.body.classList.remove("menu-open");
//     });

//     // Close on outside click
//     document.addEventListener("click", (e) => {
//       if (!mobileNav.contains(e.target) && !menuBtn.contains(e.target)) {
//         mobileNav.classList.remove("open");
//         document.body.classList.remove("menu-open");
//       }
//     });
//   }
// });

async function loadSheetData() {
    const loader_spinner = document.getElementById("loader");
    const table = document.getElementById("sheetTable");

    if (!loader_spinner || !table) {
        
        console.error("Missing element in the DOM.");
        return;
    }
    loader_spinner.style.display = "block";

    try {
    const res = await fetch('/api.php');
    const data = await res.json();
    

    if (data.error) {
        document.getElementById('sheetTable').innerHTML = `<tr><td>${data.error}</td></tr>`;
        return;
    }

    let html = "";
    data.forEach((row, index) => {
        html += "<tr>";
        row.forEach((cell, colIndex) => {
        if (index === 0) {
            html += `<th>${cell}</th>`;
        } else {
            if (colIndex === 3) { 
            // Split the text by newline or comma if needed
            let items = cell.split("\n");
            let formatted = items.map(item => 
                `${item}<hr style="margin: 4px 0; border: 0; border-top: 1px solid #ccc;">`
            ).join("");

            html += `<td>${formatted}</td>`;
            } else {

            html += `<td>${cell}</td>`;
            }
        }
        });
        html += "</tr>";
    });

    document.getElementById('sheetTable').innerHTML = html;
    } catch (err) {
    document.getElementById('sheetTable').innerHTML = `<tr><td>Error loading data</td></tr>`;
    } finally {
    // Hide loader after data load
    loader_spinner.style.display = "none";
    }
}
// document.addEventListener("DOMContentLoaded", loadSheetData);
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector("#loader") && document.querySelector("#sheetTable")) {
        loadSheetData();
    }
});



// Export for debugging
window.clearSearch = clearSearch;